/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

/**
 * Component.
 */
@Component({ name: 'status-in-service-point-component' })
export default class extends Vue {
  /**
   * Property `windowHeight`;
   */
  windowHeight = null;

  /**
   * Property `servicePoint`.
   */
  @Prop({ default: null, type: String })
  servicePoint: string;

  /**
   * Property `client`.
   */
  @Prop({ type: String })
  client: string;

  /**
   * Property `client`.
   */
  @Prop({ default: false, type: Boolean })
  isScanningQrcode: boolean;

  /**
   * Property `orderType`.
   */
  @Prop({ default: null, type: String })
  orderType: string;

  /**
   * Property `expectedDeliveryDate`.
   */
  @Prop({ default: null, type: String })
  expectedDeliveryDate: boolean;

  /**
   * Property `servicePointRetentionTime`.
   */
  @Prop({ default: null, type: Number })
  servicePointRetentionTime: number;

  /**
   * Property `numberOfPackages`.
   */
  @Prop({ default: 0, type: Number })
  numberOfPackages: number;

  /**
   * Getter `isDelivery`
   */
  get isDelivery() {
    return this.orderType === 'DELIVERY';
  }

  /**
   * Getter status title.
   */
  get statusTitle() {
    return this.i18n('TRACKING.SENTENCES.STATUS_HELLO', false, 'upperFirst', {
      name: this.client || '-'
    });
  }

  /**
   * Getter status sentence.
   */
  get statusSentence() {
    const { expectedDeliveryDate, servicePoint: name = null } = this || {};

    let message = this.i18n(
      `TRACKING.SENTENCES.STATUS_${
        this.isDelivery ? 'DELIVERY' : 'COLLECT'
      }_IN_SERVICE_POINT`,
      false,
      'plain',
      {
        name: `<b>${name || '-'}</b>`,
        packages:
          this.numberOfPackages > 1
            ? this.i18n(
              'TRACKING.SENTENCES.NUMBER_OF_PACKAGES',
              false,
              'plain',
              { total: this.numberOfPackages }
            )
            : ''
      }
    );

    const retentionDays = this.servicePointRetentionTime || 0;

    if (!this.isScanningQrcode && this.isDelivery && retentionDays) {
      const deliveryDate = this.$moment(expectedDeliveryDate);
      const expiringDate = this.$moment(deliveryDate).add(
        retentionDays,
        'days'
      );

      message =
        message +
        ` ${this.i18n(
          'TRACKING.SENTENCES.STATUS_DELIVERY_IN_SERVICE_POINT_UNTIL',
          false,
          'plain',
          { date: this.$moment(expiringDate).format('DD MMM YYYY') }
        )}`;
    }

    if (this.isScanningQrcode) {
      message = this.i18n(
        `TRACKING.SENTENCES.SHOW_${
          this.isDelivery ? 'DELIVERY' : 'COLLECT'
        }_QR_CODE`
      );
    }

    return message;
  }

  /**
   * Getter `extraSmallScreenHeight`.
   */
  get extraSmallScreenHeight() {
    return this.windowHeight <= 320;
  }

  /**
   * Lifecycle mounted hook.
   */
  mounted() {
    this.handleOnResize();

    this.$nextTick(() => {
      window.addEventListener('resize', this.handleOnResize);
    });
  }

  /**
   * Lifecycle destroyed hook.
   */
  destroyed() {
    window.removeEventListener('resize', this.handleOnResize);
  }

  /**
   * Handle on resize.
   */
  handleOnResize() {
    this.windowHeight = window.innerHeight;
  }

  /**
   * Handle window height.
   */
  @Watch('windowHeight')
  handlewindowHeight(value) {
    this.windowHeight = value;
  }
}
